export const FirstLoginToday = "first_login";
export const ContinuedLogin = "continued_login";
export const RunSimulation = "run_simulation";
